import { render, staticRenderFns } from "./happyfox_section.vue?vue&type=template&id=6ba1de7a&"
import script from "./happyfox_section.vue?vue&type=script&lang=js&"
export * from "./happyfox_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports